import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { map } from 'rxjs';

export const batchGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  return userService.fetchUser$.pipe(
    map((user) =>
      user.userType === 'CS' ? true : router.parseUrl('/distribution-center/package-orders')
    )
  );
};
